import { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { ButtonV2, IconButtonV2, TextArea } from '@utilities';
import { ArrowRightIcon, StackIcon } from '@utilities/icons';

import Column from '../../../../layouts/Column';
import Footer from '../../../../../../components/Footer';

import styles from './_index.module.scss';

const NarrativesChatLandingPage = ({ onNavigation, onSubmit }) => {
  const [inputValue, setInputValue] = useState('');

  const trimmedValue = inputValue.trim();
  const hasInputText = Boolean(trimmedValue);

  const handleChangeInput = (value) => setInputValue(value);

  const handleSubmit = () => {
    if (!hasInputText) return;

    onSubmit(trimmedValue);
    onNavigation('chat');
  };

  const handleInputKeyDown = (event) => {
    if (event.key !== 'Enter' || event.shiftKey) return;

    event.preventDefault();
    handleSubmit();
  };

  return (
    <Column className={styles['chat-landing-page']}>
      <div className={styles['chat-landing-page-content']}>
        <h1 className={styles['chat-header']}>What business question do you have?</h1>
        <h2 className={styles['chat-subheader']}>Every narrative begins with a question.</h2>
        <div className={styles['chat-input-field']}>
          <div className={styles['chat-input-textarea']}>
            <TextArea
              autoFocus
              autoGrow
              className={styles['chat-input-control']}
              onChange={handleChangeInput}
              onKeyDown={handleInputKeyDown}
              placeholder="What would you like to know?"
              rows={1}
              value={inputValue}
            />
          </div>

          <span
            className={classNames(styles['chat-input-submit'], {
              [styles['chat-input-submit-filled']]: hasInputText,
            })}
          >
            <IconButtonV2
              aria-label="Submit prompt"
              disabled={!hasInputText}
              icon={<ArrowRightIcon />}
              onClick={handleSubmit}
              size="small"
              variant="subtle"
            />
          </span>
        </div>
        <p>Need inspiration?</p>
        <ButtonV2
          className={styles['chat-template-button']}
          icon={<StackIcon />}
          onClick={() => onNavigation('templates')}
          variant="subtle"
        >
          Browse our Project Templates
        </ButtonV2>
      </div>
      <Footer />
    </Column>
  );
};

NarrativesChatLandingPage.propTypes = {
  onNavigation: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default NarrativesChatLandingPage;
